module.exports = "/_next/static/images/mussels-6ba5028f99d098d7e836a09310f75960.png";